import { CalendarItemType } from '@akin-home/amplify';
import {
  addRecurrenceEndDate,
  createRecurringItem,
  generateRecurrences,
} from '@akin-home/recurrence';
import { addRecurrenceChecklistData } from '@akin-home/recurrence/checklists';
import { pipe } from '@akin-home/utils/fp';
import { add } from 'date-fns';
import { v4 as uuid } from 'uuid';
import { Event } from './../types';

export const createEventModel = (input: Partial<Event>): Event => ({
  type: CalendarItemType.Event,
  allDay: false,
  checklist: [],
  todo: [],
  id: uuid(),
  habitatID: '',
  recurrenceExcludeDates: {},
  title: '',
  participants: [],
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
  ...input,
  start: input.start || new Date(),
  end: input.end || add(input.start || new Date(), { hours: 1 }),
});

export const generateEventRecurrences = generateRecurrences<Event>(
  ({ item, recurrenceDate }) =>
    pipe(
      createRecurringItem,
      addRecurrenceEndDate(item as any),
      addRecurrenceChecklistData(item as any)
    )({ item, recurrenceDate })
);

export const eventDatesToObjects = (event: { start: string; end: string }) => ({
  ...event,
  start: new Date(event.start),
  end: new Date(event.end),
});